/* zm-reviews */
(function () {
  var container = document.querySelector('.zm-reviews-zm-reviews');
  if (!container) return;
  var track = container.querySelector('[data-zm-reviews-track]');
  var cards = track.children;
  var dots = container.querySelectorAll('[data-zm-reviews-dots] button');
  var prevBtn = container.querySelector('[data-zm-reviews-prev]');
  var nextBtn = container.querySelector('[data-zm-reviews-next]');
  var current = 0;
  var autoplayDelay = 5000;
  var autoplayTimer = null;
  var isPointerDown = false;

  function goTo(index) {
    if (index < 0) index = cards.length - 1;
    if (index >= cards.length) index = 0;
    current = index;
    var card = cards[current];
    if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    updateDots();
  }

  function updateDots() {
    dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(function () { goTo(current + 1); }, autoplayDelay);
  }

  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.dataset.index, 10));
      startAutoplay();
    });
  });

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });

  track.addEventListener('scroll', function () {
    if (isPointerDown) return;
    var cardWidth = cards[0] ? cards[0].offsetWidth + 16 : 1;
    var index = Math.round(track.scrollLeft / cardWidth);
    if (index !== current) { current = index; updateDots(); }
  });

  track.addEventListener('pointerdown', function () { isPointerDown = true; stopAutoplay(); });
  track.addEventListener('pointerup', function () {
    isPointerDown = false;
    var cardWidth = cards[0] ? cards[0].offsetWidth + 16 : 1;
    current = Math.round(track.scrollLeft / cardWidth);
    updateDots();
    startAutoplay();
  });
  track.addEventListener('mouseleave', function () { if (!isPointerDown) startAutoplay(); });

  startAutoplay();
})();

/* zm-steps */
(function () {
  var container = document.querySelector('.zm-steps-zm-steps');
  if (!container) return;
  var track = container.querySelector('[data-zm-steps-track]');
  var cards = track.children;
  var dots = container.querySelectorAll('[data-zm-steps-dots] button');
  var prevBtn = container.querySelector('[data-zm-steps-prev]');
  var nextBtn = container.querySelector('[data-zm-steps-next]');
  var current = 0;
  var autoplayTimer = null;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function updateDots() {
    dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
  }

  function goTo(index) {
    if (index < 0) index = cards.length - 1;
    if (index >= cards.length) index = 0;
    current = index;
    var card = cards[current];
    if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    updateDots();
  }

  function startAutoplay() {
    stopAutoplay();
    if (!isMobile()) return;
    autoplayTimer = setInterval(function () { goTo(current + 1); }, 4500);
  }

  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });
  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goTo(parseInt(dot.dataset.index, 10));
      startAutoplay();
    });
  });

  var isPointerDown = false;
  track.addEventListener('pointerdown', function () { isPointerDown = true; stopAutoplay(); });
  track.addEventListener('pointerup', function () {
    isPointerDown = false;
    var cardWidth = cards[0] ? cards[0].offsetWidth : 1;
    current = Math.round(track.scrollLeft / cardWidth);
    updateDots();
    startAutoplay();
  });
  track.addEventListener('scroll', function () {
    if (isPointerDown) return;
    var cardWidth = cards[0] ? cards[0].offsetWidth : 1;
    var index = Math.round(track.scrollLeft / cardWidth);
    if (index !== current) { current = index; updateDots(); }
  });

  window.addEventListener('resize', startAutoplay);
  startAutoplay();
})();

/* zm-video-reviews */
(function () {
  var container = document.querySelector('.zm-video-reviews-zm-video-reviews');
  if (!container) return;
  var track = container.querySelector('[data-zm-video-track]');
  var cards = track.children;
  var dots = container.querySelectorAll('[data-zm-video-dots] button');
  var prevBtn = container.querySelector('[data-zm-video-prev]');
  var nextBtn = container.querySelector('[data-zm-video-next]');
  var videos = container.querySelectorAll('video');
  var current = 0;

  function goTo(index) {
    if (index < 0) index = cards.length - 1;
    if (index >= cards.length) index = 0;
    current = index;
    var card = cards[current];
    if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    updateDots();
  }

  function updateDots() {
    dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.index, 10)); });
  });
  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

  var isPointerDown = false;
  track.addEventListener('scroll', function () {
    if (isPointerDown) return;
    var cardWidth = cards[0] ? cards[0].offsetWidth + 19.2 : 1;
    var index = Math.round(track.scrollLeft / cardWidth);
    if (index !== current) { current = index; updateDots(); }
  });
  track.addEventListener('pointerdown', function () { isPointerDown = true; });
  track.addEventListener('pointerup', function () {
    isPointerDown = false;
    var cardWidth = cards[0] ? cards[0].offsetWidth + 19.2 : 1;
    current = Math.round(track.scrollLeft / cardWidth);
    updateDots();
  });

  videos.forEach(function (video) {
    video.addEventListener('play', function () {
      videos.forEach(function (other) { if (other !== video) other.pause(); });
    });
  });
})();
